import { AlertIcon } from '../../styles/icons/svg'
import '../../styles/AlertModal.scss'
const AlertModal = (props) => {
    const { msg = '', onClose = () => { } } = props
    return (
        <div className="alertModal-overlay" id="modalOverlay">
            <div className='modal-container'>
                <div style={{ textAlign: 'center' }}>
                    <AlertIcon />
                </div>
                <div className='text-section'>
                    {msg}
                </div>
                <button autoFocus={true} onClick={onClose}
                    onKeyDown={(e) => {
                        if (e.keyCode === 32 || e.key === "Enter") {
                            onClose()
                        }
                    }}
                >
                    Ok
                </button>
            </div>
        </div>
    )
}

export default AlertModal